import { Grid, Typography } from '@mui/material';
import { WsColors, WsTypoColors, WsTypography, WsTypoVariants } from 'wisestep-base';

interface ClientDetailsTextProps {
  titleType: string;
  titleText: string;
  onClickTitleText?: () => void;
}
const ClientDetailsCard = ({ titleType, titleText, onClickTitleText }: ClientDetailsTextProps) => {
  return (
    <Grid item xs={6}>
      <WsTypography color={WsTypoColors.SECONDARY} variant={WsTypoVariants.BODY2}>
        {titleType}
      </WsTypography>
      <Typography
        color={titleText ? WsColors.TheBlues600 : WsColors.GenericRichBlack}
        fontWeight="bold"
        fontSize="14px"
        onClick={onClickTitleText}
        sx={{ cursor: onClickTitleText && 'pointer' }}
      >
        {titleText}
      </Typography>
    </Grid>
  );
};
export default ClientDetailsCard;
